var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: _vm.hide,
          expression: "hide",
        },
      ],
      staticClass: "month-picker-input-container",
    },
    [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.selectedDate,
            expression: "selectedDate",
          },
        ],
        staticClass: "month-picker-input",
        attrs: { type: "text", placeholder: _vm.placeholder, readonly: "" },
        domProps: { value: _vm.selectedDate },
        on: {
          click: function ($event) {
            return _vm.showMonthPicker()
          },
          input: function ($event) {
            if ($event.target.composing) return
            _vm.selectedDate = $event.target.value
          },
        },
      }),
      _vm._v(" "),
      _c("month-picker", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.monthPickerVisible,
            expression: "monthPickerVisible",
          },
        ],
        attrs: {
          "default-year": _vm.defaultYear,
          "default-month": _vm.defaultMonth,
          lang: _vm.lang,
          months: _vm.months,
          "no-default": _vm.noDefault,
          "show-year": _vm.showYear,
          "highlight-exact-date": _vm.highlightExactDate,
          clearable: _vm.clearable,
          variant: _vm.variant,
          "editable-year": _vm.editableYear,
          "max-date": _vm.maxDate,
          "min-date": _vm.minDate,
          "year-only": _vm.yearOnly,
          range: _vm.range,
        },
        on: { input: _vm.populateInput, change: _vm.updateDate },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }